<template>
  <div>
    <div class="login-btn login-btn-white" @click="goGoogleAuth" v-if="styleType=='bar'"> <!-- facebookLogin -->
        <img class="login_icon" src="../../../assets/img/h5_login_google.png" />
        <span>{{$t('m.log_in_using_Google')}}</span>
    </div>
    <div class="img_box" @click="goGoogleAuth" v-else>
      <img class="login_other_img" src="../../../assets/img/h5_login_icon11.png" />
    </div>
  </div>
</template>
<script>
import { Toast } from "vant";
import { myMixin } from "@/tools/mixins.js";
export default {
  name: "LoginGoogle",
  mixins: [myMixin],
  props: {
    styleType: {
      type: String,
      default: 'bar'//bar 长条状 circle 其他方式圆形状
    }
  },
  data() {
    return {

    };
  },
  computed: {},
  mounted() {
    // https://pay.buzzcast.info/#/login?type=google&userid=101505751153323067434&access_token=ya29.A0AS3H6NyqiYMyXpTl9kTTzc4NrJ0etCLfRFNnKrwYYU-qaaHIsc3XcF6m3ukcEhVaA9nDnxIlshP46Rw0KI7pPRxb76US2DagGkRcVt7qhSNSLiquIGlSE0LbkJHsdLYJ1s1BkzZDCu0IIkfa-R3PNGue91GhprfNSVuUoEemIShbTrTUPXopV94CXzqZAbwpW2d6CMFFaCgYKAQUSARQSFQHGX2MiO8HnhjM6Si34h3FTpRKRJg0207
    //http://localhost:8080/#/login?type=google&id=userid%3D101562275720041118292&access_token=ya29.a0AfH6SMBmFPsjLIZLXmoZcaQ6a04m6VX77r3lEU_3PUW2SZTvfEbcZPnBJfcnVFPuLjqXP5yz5aeT4twlCveG4IdB_wjVgIbBySGDJ5ZR2W8ASP5G41ebGykKkwZmeXn2ilR_qUBNPd6Z3Zk0F9rVTxg-diYauw
    let type = this.getParamsHash('type');
    console.log(type);
    // let userid = this.getParamsHash('userid');
    // let access_token = this.getParamsHash('access_token');
     let googleAccessToken =  location.href.split('&')[1]  ;
    if(type==='google'&&googleAccessToken){
      this.confirmLogin(9,{
        "uid":'',
        "accessToken":'',
        googleAccessToken:googleAccessToken
      });
    }
  },
  methods: {
    goGoogleAuth() {
      let platform = 'bcnewpay'+this.getSuffix()
      this.gosdkAuth(1,`googleAuth.html?platform=${platform}`)
    }
    // goAuth(){
    //   window.location.href="https://callb.xuoj.com/loginAuth/googleAuth.html?suiji="+Date.parse(new Date());
    // },

  },
};
</script>
<style scoped>
.login_icon {
  width: 0.46rem;
  height: 0.46rem;
  position: absolute;
  top: 0.25rem;
  left: 0.5rem;
}
.login-btn {
  width: 100%;
  height: 0.96rem;
  font-size: 0.3rem;
  line-height: 0.96rem;
  background-color: #008aff;
  position: relative;
  text-align: center;
  color: #fff;
  border-radius: 0.96rem;
  margin-bottom: 0.45rem;
  box-sizing: border-box;
}
.login-btn-white {
  background-color: #fff;
  color: #333;
  box-shadow: 0 0.01rem 0.25rem 0 rgba(11, 79, 218, 0.13);
}
.img_box {
  margin: 0 0.15rem;
}
.login_other_img {
  width: 0.76rem;
  height: 0.76rem;
  border-radius: 50%;
}
.fr .login-btn{
  padding: 0 0.3rem 0 1rem;
}
</style>



// WEBPACK FOOTER //
// src/components/Login/LoginSdk/LoginSdkGoogle.vue